import React from 'react';

const HSNCodeTableFormForStockCredit = (props) => {
    return (
        <div className="itemList-table w-full" >
            <div className="table-container h-[250px] overflow-y-scroll">
                <table className="itemList">
                    <thead>
                        <tr>
                            <td className='w-[3%]'>Sr.</td>
                            <td className='w-[16%]'>HSN Code</td>
                            <td className='w-[15%]'>Amount</td>
                            <td className='w-[10%]'>SGST Rate</td>
                            <td className='w-[12%]'>SGST Amount</td>
                            <td className='w-[10%]'>CGST Rate</td>
                            <td className='w-[12%]'>CGST Amount</td>
                            <td className='w-[10%]'>IGST Rate</td>
                            <td className='w-[12%]'>IGST Amount</td>
                        </tr>
                    </thead>
                    <tbody>
                        {props.hsnCodeListForTable && props.hsnCodeListForTable.length > 0
                            ? props.hsnCodeListForTable.map((item, key) => (

                                <tr key={key}>
                                    <td>{key + 1}</td>
                                    <td>{item.hsnCodeName}</td>
                                    <td>{item.taxableAmount}</td>
                                    <td>{item.sgst}%</td>
                                    <td>{item.sgstAmount}</td>
                                    <td>{item.cgst}%</td>
                                    <td>{item.cgstAmount}</td>
                                    <td>{item.igst}%</td>
                                    <td>{item.igstAmount}</td>
                                    {/* <td>{item.utgst}%</td>
                                    <td>{item.utgstAmount}</td> */}
                                </tr>
                            ))
                            : null}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default HSNCodeTableFormForStockCredit;